interface Option {
    id: number | string;
    name: string | number;
}

const geoFenceTypes: Option[] = [];
geoFenceTypes.push({ id: 1, name: 'Polygon' });
geoFenceTypes.push({ id: 2, name: 'Circle' });

const stagingGeoFenceTypes: Option[] = [];
stagingGeoFenceTypes.push({ id: 1, name: 'Polygon' });
stagingGeoFenceTypes.push({ id: 2, name: 'Circle' });
stagingGeoFenceTypes.push({ id: 3, name: 'None' });

export { geoFenceTypes, stagingGeoFenceTypes };
